"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var events_1 = require('events');
var ray = require('voxel-raycast');
var raycast = require('fast-voxel-raycast');
var aabb = require('aabb-3d');
var vector = require('gl-vec3');
var SpatialEventEmitter = require('spatial-events');
var regionChange = require('voxel-region-change');
var physics_1 = require('@voxeline/physics');
var tic = require('tic')();
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var createRay = require('ray-aabb');
var isndarray = require('isndarray');
var MAX_SAFE_INTEGER = require('max-safe-integer');
var EffectManager_1 = require('./EffectManager');
var artpacks_1 = require('./artpacks');
var extend = require('extend');
var voxel_1 = require('./voxel');
var types_1 = require('./types');
var detector_1 = require('./detector');
var plugins_1 = require('./plugins');
var Registry_1 = require('./Registry');
var Stitcher_1 = require('./Stitcher');
var Renderer_1 = require('./Renderer');
var Mesher_1 = require('./Mesher');
var SpriteManager_1 = require('./SpriteManager');
var createShell = require('gl-now');
var BUILTIN_PLUGIN_OPTS = {};
var _position = vec3.create();
var _cameraVector = vec3.create();
var v0 = vec3.create();
var v1 = vec3.create();
var _aabb = new physics_1.AABB(v0, v1);
var Game = (function (_super) {
    __extends(Game, _super);
    function Game(shell, opts) {
        var _this = this;
        _super.call(this);
        // // only intersects voxels, not items (for now)
        // raycast(start, direction, maxDistance, epilson?) {
        //   return this.raycastVoxels(start, direction, maxDistance, epilson);
        // }
        this.getVoxel = function (x, y, z) {
            var val = _this.voxels.getVoxel(x, y, z);
            // TODO: Remove hard-coded block 1 filter
            return val > 1 ? val : 0;
        };
        this.getSolidVoxel = function (x, y, z) {
            var val = _this.voxels.getVoxel(x, y, z);
            return _this.isSolidVoxel(val) ? val : 0;
        };
        this.isSolidVoxel = function (id) {
            if (!id)
                return false;
            var props = _this.registry.getBlockProps(id);
            return props && !props.blockModel;
        };
        this.testSolidVoxel = function (x, y, z) {
            var tile = _this.voxels.getVoxel(x, y, z);
            if (!tile)
                return false;
            return _this.isSolidVoxel(tile);
        };
        this.testFluidVoxel = function () { return false; };
        this.raycastSolidVoxels = function (start, direction, maxDistance, hitPos, hitNormal) {
            return raycast(_this.getSolidVoxel, start, direction, maxDistance, hitPos, hitNormal);
        };
        // # Defaults/options parsing
        this.friction = 0.3;
        this.epilson = 1e-8;
        this.terminalVelocity = [0.9, 0.1, 0.9];
        // # Misc internal methods
        this.setInterval = tic.interval.bind(tic);
        this.setTimeout = tic.timeout.bind(tic);
        this.getTickID = function () { return _this.tickID; };
        this.fpsControlOptions = opts.fpsControlOptions || {};
        this.ray = createRay([0, 0, 0], [0, 0, 1]);
        this.shell = shell;
        this.sunlight = vec3.fromValues(0, 0, 0);
        this.clock = 0;
        this.objects = [];
        this.objectsIndexed = new Map();
        if (opts.pluginOpts && opts.pluginOpts['voxel-engine'])
            opts = extend(opts, opts.pluginOpts['voxel-engine']);
        if (opts.pluginOpts && opts.pluginOpts['voxel-engine-stackgl'])
            opts = extend(opts, opts.pluginOpts['voxel-engine-stackgl']);
        if (this.notCapable())
            return;
        // is this a client or a headless server
        this.isClient = Boolean((typeof opts.isClient !== 'undefined') ? opts.isClient : true);
        this.generateChunks = opts.generateChunks !== false;
        this.setConfigurablePositions(opts);
        this.configureChunkLoading(opts);
        this.setDimensions(opts);
        this.arrayType = opts.arrayType || { 1: Uint8Array, 2: Uint16Array, 4: Uint32Array }[opts.arrayTypeSize] || Uint16Array;
        this.cubeSize = 1; // backwards compat
        this.chunkSize = opts.chunkSize || 32;
        this.chunkPad = opts.chunkPad || 4;
        // chunkDistance and removeDistance should not be set to the same thing
        // as it causes lag when you go back and forth on a chunk boundary
        this.chunkDistance = opts.chunkDistance || 2;
        this.removeDistance = opts.removeDistance || this.chunkDistance + 1;
        this.skyColor = opts.skyColor || 0xBFD1E5;
        this.antialias = opts.antialias;
        this.playerHeight = opts.playerHeight || 1.62;
        this.meshType = opts.meshType || 'surfaceMesh';
        this.items = [];
        this.voxels = new voxel_1.Chunker(this);
        // setup plugins
        var pluginLoaders = opts.pluginLoaders || {};
        extend(pluginLoaders, {
            'voxel-engine-stackgl': Game,
        });
        var plugins = plugins_1.default(this, {
            masterPluginName: 'voxel-engine-stackgl',
            loaders: pluginLoaders,
        });
        this.timer = this.initializeTimer((opts.tickFPS || 16));
        this.paused = false;
        this.spatial = new SpatialEventEmitter;
        this.region = regionChange(this.spatial, aabb([0, 0, 0], [1, 1, 1]), this.chunkSize);
        this.voxelRegion = regionChange(this.spatial, 1);
        this.chunkRegion = regionChange(this.spatial, this.chunkSize);
        this.asyncChunkGeneration = false;
        // contains chunks that has had an update this tick. Will be generated right before redrawing the frame
        this.chunksNeedsUpdate = {};
        // contains new chunks yet to be generated. Handled by game.loadPendingChunks
        this.pendingChunks = [];
        this.tickID = 0;
        // client side only after this point
        if (!this.isClient)
            return;
        //this.paused = true // TODO: should it start paused, then unpause when pointer lock is acquired?
        // Initialize stitch
        var artpacks = artpacks_1.default(opts.artpacks);
        this.registry = new Registry_1.default(artpacks);
        for (var _i = 0, _a = opts.blocks; _i < _a.length; _i++) {
            var block = _a[_i];
            this.registry.registerBlock(block);
        }
        var gl = this.shell.gl;
        this.stitcher = new Stitcher_1.default(gl, this.registry, artpacks);
        this.sprites = new SpriteManager_1.default(gl, this.stitcher);
        this.mesher = new Mesher_1.default(gl, this.registry, this.stitcher, this.chunkSize);
        this.physics = new physics_1.Physics(null, this.testSolidVoxel, this.testFluidVoxel);
        this.effectManager = new EffectManager_1.default();
        this.renderer = new Renderer_1.default(gl, this.mesher, this.stitcher, this.effectManager);
        // setup plugins
        var pluginOpts = opts.pluginOpts || {};
        for (var name_1 in BUILTIN_PLUGIN_OPTS) {
            pluginOpts[name_1] = pluginOpts[name_1] || BUILTIN_PLUGIN_OPTS[name_1];
        }
        for (var name_2 in pluginOpts) {
            plugins.add(name_2, pluginOpts[name_2]);
        }
        plugins.loadAll();
        // textures loaded, now can render chunks
        this.stitcher.on('updatedSides', function () {
            if (_this.generateChunks)
                _this.handleChunkGeneration();
            _this.showAllChunks();
            // TODO: fix async chunk gen, loadPendingChunks() may load 1 even if this.pendingChunks empty
            setTimeout(function () {
                _this.asyncChunkGeneration = 'asyncChunkGeneration' in opts ? opts.asyncChunkGeneration : true;
            }, 2000);
        });
        this.emit('engine-init', this);
        this.shell.bind('left', 'left', 'A');
        this.shell.bind('right', 'right', 'D');
        this.shell.bind('forward', 'up', 'W');
        this.shell.bind('backward', 'down', 'S');
        this.shell.bind('jump', 'space');
        this.shell.bind('crouch', 'shift');
        this.itemRegistry = new Map();
        this.modelRegistry = new Map();
    }
    Game.createContainer = function () {
        // based on game-shell makeDefaultContainer()
        var container = document.createElement("div");
        container.tabIndex = 1;
        container.style.position = "absolute";
        container.style.left = "0px";
        container.style.right = "0px";
        container.style.top = "0px";
        container.style.bottom = "0px";
        container.style.height = "100%";
        container.style.overflow = "hidden";
        document.body.appendChild(container);
        document.body.style.overflow = "hidden"; //Prevent bounce
        document.body.style.height = "100%";
        return container;
    };
    Game.initShell = function (options) {
        if (options === void 0) { options = {}; }
        var skyColor = options.skyColor || 0xBFD1E5;
        var clearColor = [
            (skyColor >> 16) / 255.0,
            ((skyColor >> 8) & 0xff) / 255.0,
            (skyColor & 0xff) / 255.0,
            1.0,
        ];
        var pointerLock = options.pointerLock !== undefined ? options.pointerLock : true;
        var stickyPointerLock = options.stickyPointerLock !== undefined ? options.stickyPointerLock : pointerLock;
        var element = options.container || Game.createContainer();
        return new Promise(function (resolve, reject) {
            var shell = createShell({
                clearColor: clearColor,
                pointerLock: pointerLock,
                stickyPointerLock: stickyPointerLock,
                element: element,
            });
            shell.once('gl-init', function () { return resolve(shell); });
            shell.once('gl-error', function (err) { return reject(err); });
        });
    };
    Game.prototype.toString = function () {
        return 'voxel-engine-stackgl';
    };
    // # External API
    Game.prototype.voxelPosition = function (gamePosition) {
        var _ = Math.floor;
        var p = gamePosition;
        var v = [];
        v[0] = _(p[0]);
        v[1] = _(p[1]);
        v[2] = _(p[2]);
        return v;
    };
    Game.prototype.render = function (camera) {
        var _this = this;
        var keys = Object.keys(this.voxels.chunks);
        var chunks = keys.map(function (key) { return _this.voxels.chunks[key]; });
        this.renderer.onRender(camera, chunks, this.objects, this.sunlight, this.focusedVoxel);
    };
    Game.prototype.addItem = function (itemId, model) {
        if (this.itemRegistry.has(itemId)) {
            throw new Error("Duplicate item id: " + itemId);
        }
        var item = {
            id: itemId,
            vao: model.vao,
            size: model.shape,
        };
        this.itemRegistry.set(itemId, item);
        return item;
    };
    Game.prototype.getItem = function (itemId) {
        return this.itemRegistry.get(itemId);
    };
    Game.prototype.removeItem = function (item) {
        var ix = this.items.indexOf(item);
        if (ix < 0)
            return;
        this.items.splice(ix, 1);
        if (item.mesh)
            this.scene.remove(item.mesh);
    };
    Game.prototype.raycastVoxels = function (start, direction, maxDistance, hitPos, hitNormal) {
        return raycast(this.getVoxel, start, direction, maxDistance, hitPos, hitNormal);
    };
    Game.prototype.canCreateBlock = function (pos) {
        pos = this.parseVectorArguments(arguments);
        var floored = pos.map(function (i) { return Math.floor(i); });
        var bbox = aabb(floored, [1, 1, 1]);
        for (var i = 0, len = this.items.length; i < len; ++i) {
            var item = this.items[i];
            var itemInTheWay = item.blocksCreation && item.aabb && bbox.intersects(item.aabb());
            if (itemInTheWay)
                return false;
        }
        return true;
    };
    // createBlock(pos, val) {
    //   if (typeof val === 'string') val = this. materials.find(val)
    //   if (!this.canCreateBlock(pos)) return false
    //   // this.setBlock(pos, val)
    //   return true
    // }
    Game.prototype.setBlock = function (x, y, z, val) {
        var old = this.voxels.setVoxel(x, y, z, val);
        var c = this.voxels.getChunkPosition(x, y, z);
        var chunk = this.voxels.chunks[c.join('|')];
        if (!chunk)
            return; // todo - does self.emit('missingChunk', c.join('|')) make sense here?
        this.addChunkToNextUpdate(chunk);
        // this.spatial.emit('change-block', pos, old, val);
        // this.emit('setBlock', pos, val, old);
    };
    Game.prototype.getBlock = function (pos) {
        pos = this.parseVectorArguments(arguments);
        return this.voxels.voxelAtPosition(pos);
    };
    Game.prototype.blockPosition = function (pos) {
        pos = this.parseVectorArguments(arguments);
        var ox = Math.floor(pos[0]);
        var oy = Math.floor(pos[1]);
        var oz = Math.floor(pos[2]);
        return [ox, oy, oz];
    };
    Game.prototype.blocks = function (low, high, iterator) {
        var l = low, h = high;
        var d = [h[0] - l[0], h[1] - l[1], h[2] - l[2]];
        var voxels = iterator || new this.arrayType(d[0] * d[1] * d[2]);
        var i = 0;
        for (var z = l[2]; z < h[2]; ++z)
            for (var y = l[1]; y < h[1]; ++y)
                for (var x = l[0]; x < h[0]; ++x, ++i) {
                    if (iterator)
                        iterator(x, y, z, i);
                    else
                        voxels[i] = this.voxels.voxelAtPosition([x, y, z]);
                }
        if (!iterator)
            return { voxels: voxels, dims: d };
    };
    // // backwards compat
    // createAdjacent(hit, val) {
    //   this.createBlock(hit.adjacent, val)
    // }
    Game.prototype.appendTo = function (element) {
        // no-op; game-shell to append itself
    };
    // used in methods that have identity function(pos) {}
    Game.prototype.parseVectorArguments = function (args) {
        if (!args)
            return false;
        if (args[0] instanceof Array)
            return args[0];
        return [args[0], args[1], args[2]];
    };
    Game.prototype.setConfigurablePositions = function (opts) {
        var sp = opts.startingPosition;
        this.startingPosition = sp || [35, 1024, 35];
        var wo = opts.worldOrigin;
        this.worldOrigin = wo || [0, 0, 0];
    };
    Game.prototype.createContainer = function (opts) {
        if (opts.container)
            return opts.container;
        // based on game-shell makeDefaultContainer()
        var container = document.createElement("div");
        container.tabIndex = 1;
        container.style.position = "absolute";
        container.style.left = "0px";
        container.style.right = "0px";
        container.style.top = "0px";
        container.style.bottom = "0px";
        container.style.height = "100%";
        container.style.overflow = "hidden";
        document.body.appendChild(container);
        document.body.style.overflow = "hidden"; //Prevent bounce
        document.body.style.height = "100%";
        return container;
    };
    Game.prototype.setDimensions = function (opts) {
        if (opts.container)
            this.container = opts.container;
        if (opts.container && opts.container.clientHeight) {
            this.height = opts.container.clientHeight;
        }
        else {
            this.height = typeof window === "undefined" ? 1 : window.innerHeight;
        }
        if (opts.container && opts.container.clientWidth) {
            this.width = opts.container.clientWidth;
        }
        else {
            this.width = typeof window === "undefined" ? 1 : window.innerWidth;
        }
    };
    Game.prototype.notCapable = function () {
        if (!detector_1.default().webgl) {
            if (!this.reportedNotCapable)
                document.body.appendChild(this.notCapableMessage());
            this.reportedNotCapable = true; // only once
            return true;
        }
        return false;
    };
    Game.prototype.notCapableMessage = function () {
        var wrapper = document.createElement('div');
        wrapper.className = "errorMessage";
        var a = document.createElement('a');
        a.title = "You need WebGL and Pointer Lock (Chrome 23/Firefox 14) to play this game. Click here for more information.";
        a.innerHTML = a.title;
        a.href = "http://get.webgl.org";
        wrapper.appendChild(a);
        return wrapper;
    };
    // # Physics/collision related methods
    /**
     * Get the position of the player under control.
     * If there is no player under control, return
     * current position of the game's camera.
     *
     * @return {Array} an [x, y, z] tuple
     */
    // # Chunk related methods
    Game.prototype.configureChunkLoading = function (opts) {
        var _this = this;
        if (!opts.generateChunks)
            return;
        if (!opts.generate) {
            this.generate = voxel_1.generator.Valley;
        }
        else if (typeof opts.generate === 'string') {
            throw new Error('Does not support this');
        }
        else {
            this.generate = opts.generate;
        }
        if (opts.generateVoxelChunk) {
            this.generateVoxelChunk = opts.generateVoxelChunk;
        }
        else {
            this.generateVoxelChunk = function (low, high) { return voxel_1.generate(low, high, _this.generate); };
        }
    };
    Game.prototype.worldWidth = function () {
        return this.chunkSize * 2 * this.chunkDistance;
    };
    Game.prototype.chunkToWorld = function (pos) {
        return [
            pos[0] * this.chunkSize,
            pos[1] * this.chunkSize,
            pos[2] * this.chunkSize
        ];
    };
    Game.prototype.removeFarChunks = function (playerPosition) {
        var _this = this;
        playerPosition = playerPosition;
        var nearbyChunks = this.voxels.nearbyChunks(playerPosition, this.removeDistance).map(function (chunkPos) { return chunkPos.join('|'); });
        Object.keys(this.voxels.chunks).map(function (chunkIndex) {
            if (nearbyChunks.indexOf(chunkIndex) > -1)
                return;
            var chunk = _this.voxels.chunks[chunkIndex];
            var mesh = _this.voxels.meshes[chunkIndex];
            var pendingIndex = _this.pendingChunks.indexOf(chunkIndex);
            if (pendingIndex !== -1)
                _this.pendingChunks.splice(pendingIndex, 1);
            if (!chunk)
                return;
            if (mesh) {
                // dispose of the gl-vao meshes
                for (var key in mesh.vertexArrayObjects) {
                    mesh.vertexArrayObjects[key].dispose();
                }
            }
            delete _this.voxels.chunks[chunkIndex];
            delete _this.voxels.meshes[chunkIndex];
            _this.emit('removeChunk', chunk.position);
        });
    };
    Game.prototype.addChunkToNextUpdate = function (chunk) {
        this.chunksNeedsUpdate[chunk.position.join('|')] = chunk;
    };
    Game.prototype.updateDirtyChunks = function () {
        var _this = this;
        Object.keys(this.chunksNeedsUpdate).forEach(function (chunkIndex) {
            var chunk = _this.chunksNeedsUpdate[chunkIndex];
            _this.emit('dirtyChunkUpdate', chunk);
            _this.showChunk(chunk);
        });
        this.chunksNeedsUpdate = {};
    };
    Game.prototype.loadPendingChunks = function (count) {
        var pendingChunks = this.pendingChunks;
        if (!this.asyncChunkGeneration) {
            count = pendingChunks.length;
        }
        else {
            count = count || (pendingChunks.length * 0.1);
            count = Math.max(1, Math.min(count, pendingChunks.length));
        }
        for (var i = 0; i < count; i += 1) {
            var chunkPos = pendingChunks[i].split('|');
            var chunk = this.voxels.generateChunk(chunkPos[0] | 0, chunkPos[1] | 0, chunkPos[2] | 0);
            if (this.isClient)
                this.showChunk(chunk);
        }
        if (count)
            pendingChunks.splice(0, count);
    };
    Game.prototype.getChunkAtPosition = function (pos) {
        var chunkID = this.voxels.chunkAtPosition(pos).join('|');
        var chunk = this.voxels.chunks[chunkID];
        return chunk;
    };
    Game.prototype.showAllChunks = function () {
        for (var chunkIndex in this.voxels.chunks) {
            this.showChunk(this.voxels.chunks[chunkIndex]);
        }
    };
    // Calculate fraction of each voxel type in chunk, for debugging
    Game.prototype.chunkDensity = function (chunk) {
        var counts = {};
        var length = chunk.data.length;
        for (var i = 0; i < length; i += 1) {
            var val = chunk.data[i];
            if (!(val in counts))
                counts[val] = 0;
            counts[val] += 1;
        }
        var densities = {};
        for (var val in counts) {
            densities[val] = counts[val] / length;
        }
        return densities;
    };
    Game.prototype.showChunk = function (chunk, optionalPosition) {
        if (optionalPosition)
            chunk.position = optionalPosition;
        var chunkIndex = chunk.position.join('|');
        this.voxels.chunks[chunkIndex] = chunk;
        this.emit('renderChunk', chunk);
    };
    Game.prototype.addModel = function (id, matrix, palette) {
        var vao = this.mesher.createObjectVao(this.shell.gl, matrix, palette, this.chunkPad);
        if (!vao)
            return null;
        var model = {
            vao: vao,
            shaderType: types_1.ShaderType.PLAIN,
            shape: vec3.fromValues(matrix.shape[0], matrix.shape[1], matrix.shape[2]),
        };
        this.modelRegistry.set(id, model);
        return model;
    };
    Game.prototype.addVoxelModel = function (id, matrix) {
        var vao = this.mesher.createVoxelObjectVao(matrix);
        if (!vao)
            return null;
        var model = {
            vao: vao,
            shaderType: types_1.ShaderType.TEXTURE_SOLID,
            shape: vec3.fromValues(matrix.shape[0], matrix.shape[1], matrix.shape[2]),
        };
        this.modelRegistry.set(id, model);
        return model;
    };
    Game.prototype.addObject = function (object) {
        if (this.objectsIndexed.has(object.id)) {
            throw new Error("Duplicate id " + object.id);
        }
        this.physics.add(object.physics);
        this.objects.push(object);
        this.objectsIndexed.set(object.id, object);
        return object;
    };
    Game.prototype.getObject = function (id) {
        return this.objectsIndexed.get(id);
    };
    // # Debugging methods
    Game.prototype.addMarker = function (position) {
        throw new Error('voxel-engine-stackgl addMarker not yet implemented TODO: figure out how to fit this into the rendering pipeline');
    };
    Game.prototype.addAABBMarker = function (aabb, color) {
        throw new Error('voxel-engine-stackgl addAABBMarker not yet implemented TODO');
    };
    Game.prototype.addVoxelMarker = function (x, y, z, color) {
        var bbox = aabb([x, y, z], [1, 1, 1]);
        return this.addAABBMarker(bbox, color);
    };
    Game.prototype.tick = function (delta) {
        this.tickID = this.tickID < MAX_SAFE_INTEGER ? this.tickID + 1 : 1;
        delta = Math.min(delta, 16);
        this.clock += delta;
        var theta = (this.clock / (5 * 1000) % 1) * 2 * Math.PI;
        if (theta > Math.PI) {
            vec3.set(this.sunlight, Math.cos(theta), -Math.sin(theta), 0);
        }
        else {
            vec3.set(this.sunlight, 0, 0, 0);
        }
        for (var i = 0, len = this.items.length; i < len; ++i) {
            this.items[i].tick(delta);
        }
        for (var _i = 0, _a = this.objects; _i < _a.length; _i++) {
            var object = _a[_i];
            object.update(delta, this.objects);
        }
        this.physics.tick(delta);
        this.effectManager.tick(delta);
        if (this.pendingChunks.length) {
            this.loadPendingChunks();
        }
        if (Object.keys(this.chunksNeedsUpdate).length > 0) {
            this.updateDirtyChunks();
        }
        tic.tick(delta);
        this.emit('tick', delta);
    };
    // TODO: merge with game-shell render loop?
    Game.prototype.initializeTimer = function (rate) {
        var _this = this;
        var accum = 0;
        var now = 0;
        var last = null;
        this.frameUpdated = true;
        this.interval = setInterval(function () {
            if (_this.paused) {
                last = Date.now();
                accum = 0;
                return;
            }
            now = Date.now();
            var dt = now - (last || now);
            last = now;
            accum += dt;
            if (accum < rate)
                return;
            var wholeTick = ((accum / rate) | 0);
            if (wholeTick <= 0)
                return;
            wholeTick *= rate;
            _this.tick(wholeTick);
            accum -= wholeTick;
            _this.frameUpdated = true;
        }, 0);
        return this.interval;
    };
    Game.prototype.handleChunkGeneration = function () {
        var _this = this;
        this.voxels.on('missingChunk', function (chunkPos) {
            _this.pendingChunks.push(chunkPos.join('|'));
        });
        this.voxels.requestMissingChunks(this.worldOrigin);
        this.loadPendingChunks(this.pendingChunks.length);
    };
    // teardown methods
    Game.prototype.destroy = function () {
        clearInterval(this.timer);
    };
    return Game;
}(events_1.EventEmitter));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Game;
//# sourceMappingURL=Game.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/Game.js
 ** module id = 907
 ** module chunks = 0
 **/